export const API_URL = 
	window.$$env.API_URL === '%{API_URL}'
    ? // eslint-disable-next-line no-undef
      `${process.env.VUE_APP_URI}`
    : window.$$env.API_URL;

export const API_LOGIN = 
	window.$$env.API_LOGIN === '%{API_LOGIN}'
    ? // eslint-disable-next-line no-undef
	`${process.env.VUE_APP_LOGIN}`
    : window.$$env.API_LOGIN;

export const WAGA_URL = 
	window.$$env.WAGA_URL === '%{WAGA_URL}'
    ? // eslint-disable-next-line no-undef
	`${process.env.VUE_APP_WAGAURL}`
    : window.$$env.WAGA_URL;

export const API_DOMAIN = 
	window.$$env.API_DOMAIN === '%{API_DOMAIN}'
    ? // eslint-disable-next-line no-undef
	`${process.env.VUE_APP_DOMAIN}`
    : window.$$env.API_DOMAIN;

export const COMPANY_ID = 
	window.$$env.COMPANY_ID === '%{COMPANY_ID}'
    ? // eslint-disable-next-line no-undef
	`${process.env.VUE_APP_COMPANY_ID}`
    : window.$$env.COMPANY_ID;



// WEBPACK FOOTER //
// ./src/components/config.js